export default __webpack_public_path__ + "static/media/OVIT_2025.a4d15002.png";